import { useMessageStore } from '@/stores/messageStore';
import React from 'react';
import { MessagePopup } from '../molecules/MessagePopup';

export const MessagePopupContainer: React.FC = () => {
  const { isVisible, title, message, type, onConfirm, onCancel, hideMessage } =
    useMessageStore();

  if (!isVisible) return null;

  return (
    <MessagePopup
      title={title}
      message={message}
      type={type}
      onClose={hideMessage}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
